module.exports = __webpack_public_path__ + "img/伦福德.png";